<template>
  <div>
    <h3 class="mt-3 mb-4 title primary--text">
      {{ $t('Training') }}
    </h3>
    <v-row class="white">
      <v-col v-if="showType === 'by_users'">
        <div class="d-flex align-center">
          <v-text-field
            v-model="searchUsers"
            append-icon="mdi-magnify"
            :label="$t('Search')"
            single-line
            hide-details
          />
          <v-btn
            class="ml-4"
            color="secondary"
            @click="exportUsersTable"
          >
            {{ $t('export') }}
          </v-btn>
        </div>

        <v-data-table
          :headers="usersTableHeaders"
          :items="laboratoryFilteredUsers"
          :search="searchUsers"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <!--          <template v-slot:item.emailIsConfirmed="{ item }">-->
          <!--            <v-checkbox-->
          <!--              :value="item.emailIsConfirmed"-->
          <!--              disabled-->
          <!--            />-->
          <!--          </template>-->

          <template v-slot:body.prepend="data">
            <tr>
              <template v-for="header in data.headers">
                <td :key="header.value">
                  <template v-if="header.value === 'training'">
                    <v-autocomplete
                      v-model="filterTrainingModuleUserTable"
                      class="my-2"
                      :items="trainingModulesNames"
                      dense
                      hide-details
                      outlined
                      color="blue-grey lighten-2"
                      :label="$t('Filter By Module')"
                      cache-items
                      clearable
                      return-object
                      item-text="name"
                    />
                  </template>
                </td>
              </template>
            </tr>
          </template>

          <template v-slot:item.avatar="{ item }">
            <user-avatar :user="item" />
          </template>

          <template v-slot:item.training="{ item }">
            <span v-if="!item.sessionData.length">-</span>
            <template v-else>
              <div
                v-for="(session, index) in item.sessionData.slice(0, 3)"
                :key="index"
              >
                Date: <b>{{ session.date.format('MM/DD/YYYY') }}</b> |
                Module name: <b>{{ session.trainingModuleName }}</b> |
                Lab: <b>{{ session.labName }}</b>
                <v-divider />
              </div>
              <template v-if="item.sessionData.length > 3">
                <div class="text-right">
                  <v-btn
                    text
                    small
                    @click="showTrainingExpandClick(item)"
                  >
                    more
                    <v-icon>{{ showTrainingExpand.includes(item.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-btn>
                </div>
                <v-expand-transition>
                  <div v-show="showTrainingExpand.includes(item.id)">
                    <div
                      v-for="(session, index) in item.sessionData.slice(3)"
                      :key="index"
                    >
                      Date: <b>{{ session.date.format('MM/DD/YYYY') }}</b> |
                      Module name <b>{{ session.trainingModuleName }}</b> |
                      Lab: <b>{{ session.labName }}</b>
                      <v-divider />
                    </div>
                  </div>
                </v-expand-transition>
              </template>
            </template>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              icon
              :to="{name: 'UserAccount', params: {userId: item.id}}"
              target="_blank"
            >
              <v-icon
                small
              >
                mdi-open-in-new
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>

      <v-col v-if="showType === 'by_modules'">
        <div class="d-flex align-center">
          <v-text-field
            v-model="searchModules"
            append-icon="mdi-magnify"
            :label="$t('Search')"
            single-line
            hide-details
          />
          <v-btn
            class="ml-4"
            color="secondary"
            @click="exportModulesTable"
          >
            {{ $t('export') }}
          </v-btn>
        </div>

        <v-data-table
          :headers="modulesTableHeaders"
          :items="trainingModules"
          :search="searchModules"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template v-slot:item.sessions="{ item }">
            <div
              v-for="(session, i) in item.sessions"
              :key="session.id"
            >
              {{ session.dateRange.split(',').join(' ~ ') }} /
              <template v-if="session.users">
                {{ session.users.length }}
              </template>
              <template v-else>
                0
              </template>
              <v-divider v-if="i < item.sessions.length - 1" />
            </div>
          </template>

          <!--          <template v-slot:item.actions="{ item }">-->
          <!--            <v-btn-->
          <!--              icon-->
          <!--              :to="{name: 'UserAccount', params: {userId: item.id}}"-->
          <!--              target="_blank"-->
          <!--            >-->
          <!--              <v-icon-->
          <!--                small-->
          <!--              >-->
          <!--                mdi-open-in-new-->
          <!--              </v-icon>-->
          <!--            </v-btn>-->
          <!--          </template>-->
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
    import moment from 'moment';
    import {
        export_json_to_excel_custom
    } from '@/vendor/Export2Excel'
    import UserAvatar from "@/components/UserAvatar";

    export default {
        name: "ReqToolTraining",

        components: {
            UserAvatar,
        },

        props: {
            laboratories: {
                type: Array,
                required: true,
            },
            laboratoriesTrainingInfo: {
                type: Object,
                required: true,
            },
            dateRange: {
                type: Array,
                required: true,
            },
            showType: {
                type: String,
                required: true,
            }
        },
        data: () => {
            return {
                searchUsers: '',
                searchModules: '',
                sortBy: 'id',
                sortDesc: false,
                showTrainingExpand: [],
                filterTrainingModuleUserTable: ''
            }
        },

        computed: {
            usersTableHeaders() {
                let headers = [
                    {
                        text: this.$t('Id'),
                        value: 'id',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Avatar'),
                        value: 'avatar',
                        align: 'start',
                        sortable: false,
                        filterable: false,
                    },
                    {
                        text: this.$t('Email'),
                        value: 'emailAddress',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('First Name'),
                        value: 'firstName',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Last Name'),
                        value: 'lastName',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Gender'),
                        value: 'gender',
                        align: 'start',
                        sortable: false,
                        filterable: false,
                    },
                    {
                        text: this.$t('Phone Number'),
                        value: 'phoneNumber',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Position'),
                        value: 'position',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Training'),
                        value: 'training',
                        align: 'start',
                        sortable: false,
                    },
                    {
                        text: this.$t('Number of days since last training'),
                        value: 'lastTrainingDateFromNowDays',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Actions'),
                        value: 'actions',
                        align: 'end',
                        sortable: false,
                    }
                ];

                return headers
            },

            modulesTableHeaders() {
                let headers = [
                    {
                        text: this.$t('Id'),
                        value: 'id',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Name'),
                        value: 'name',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Duration'),
                        value: 'duration',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Sessions'),
                        value: 'sessions',
                        align: 'start',
                        sortable: true,
                    },
                    {
                        text: this.$t('Trained Users'),
                        value: 'trainedUsers',
                        align: 'start',
                        sortable: true,
                    },
                    // {
                    //     text: 'Actions',
                    //     value: 'actions',
                    //     align: 'end',
                    //     sortable: false,
                    // }
                ];

                return headers
            },

            laboratoryUsers() {
                return this.laboratories.map(lab => lab.users).flat()
            },

            laboratoryPreFilteredUsers() {
                if (!Array.isArray(this.laboratoryUsers)) {
                    return []
                }

                let users = [...this.laboratoryUsers];

                for (let user of users) {
                    user.sessionData = this.generateTrainingData(user);
                    if(user.sessionData.length) {
                        user.lastTrainingDateFromNowDays = moment().diff(moment.max(user.sessionData.map(s => s.lastSessionDate)), 'days')
                    }
                }

                return users;
            },

            laboratoryFilteredUsers() {
                let users = this.laboratoryPreFilteredUsers;

                if(this.filterTrainingModuleUserTable) {
                    users = users.filter(user => {
                        return user.sessionData.some(s => s.trainingModuleName === this.filterTrainingModuleUserTable)
                    })
                }

                if (this.dateRange.length === 1) {
                    return users.filter(user => {
                        return user.sessionData.some(session => {
                            return session.date.isSame(this.dateRange[0], 'day');
                        })
                    })
                }

                if (this.dateRange.length) {
                    return users.filter(user => {
                        return user.sessionData.some(session => {
                            return session.date.isBetween(this.dateRange[0], this.dateRange[1], undefined, '[]')
                        })
                    })
                }

                return users;
            },


            trainingModulesNames() {
                return this.laboratoryFilteredUsers.map(u => u.sessionData.map(s => s.trainingModuleName)).flat().filter(u => u)
            },

            trainingModules() {
                return this.joinModuleToSessionToUser()
            }

        },

        methods: {
            showTrainingExpandClick(item) {
                if (this.showTrainingExpand.includes(item.id)) {
                    this.showTrainingExpand = this.showTrainingExpand.filter(e => e !== item.id)
                } else {
                    this.showTrainingExpand.push(item.id)
                }
            },

            generateTrainingData(user) {
                let userSessions = [...user?.metadata?.training || []];

                userSessions.sort((a, b) => {
                    return b.createdDate - a.createdDate;
                });

                let sessionData = [];

                for (let session of userSessions) {
                    let sessionId = session?.trainingSessionId;
                    if (!sessionId || !session.status) {
                        continue;
                    }

                    let trSession = this.findSession(sessionId);
                    let trModule = this.findModule(trSession.trainingModule);

                    let date = moment(session.createdDate);

                    let sessionMetadata = this.findLaboratoryNameFromMetadataBySession(user.metadata, sessionId);
                    if (!sessionMetadata) {
                        continue;
                    }

                    let labName = sessionMetadata.laboratoryName;

                    sessionData.push({
                        lastSessionDate: moment(trSession.dateRange.split(', ')[1]),
                        date,
                        labName,
                        trainingModuleName: trModule.name
                    })
                }

                return sessionData
            },

            joinModuleToSessionToUser() {
                let sessions = JSON.parse(JSON.stringify(this.laboratoriesTrainingInfo.trainingSessions));
                let modules = JSON.parse(JSON.stringify(this.laboratoriesTrainingInfo.trainingModules));

                sessions.forEach(session => {
                    let module = modules.find(e => e.id === session.trainingModule);
                    module.trainedUsers = 0;
                    session.module = module;
                    if (!Array.isArray(module.sessions)) {
                        module.sessions = []
                    }

                    let sessionDates = session.dateRange.trim().split(', ').sort();
                    if (this.dateRange.length) {
                        if (this.dateRange.length === 1 && moment(this.dateRange[0]).isBetween(sessionDates[0], sessionDates[1], 'day')) {
                            module.sessions.push(session)
                        } else if(this.dateRange.length > 1 && sessionDates.some(d => moment(d).isBetween(this.dateRange[0], this.dateRange[1], undefined, '[]'))) {
                            module.sessions.push(session)
                        }
                    } else {
                        module.sessions.push(session)
                    }

                });

                this.laboratoryPreFilteredUsers.forEach(user => {
                    if (user?.metadata?.training) {
                        user?.metadata?.training.forEach(t => {
                            if (t.status) {
                                let userSession = sessions.find(e => e.id == t.trainingSessionId);
                                if (userSession) {
                                    if (!Array.isArray(userSession.users)) {
                                        userSession.users = []
                                    }
                                    userSession.users.push(user);
                                    userSession.module.trainedUsers++
                                }
                            }
                        })
                    }
                });

                modules = modules.filter(m => m?.sessions?.length);

                return modules
            },

            findSession(sessionId) {
                return this.laboratoriesTrainingInfo.trainingSessions.find(e => e.id == sessionId)
            },

            findModule(moduleId) {
                return this.laboratoriesTrainingInfo.trainingModules.find(e => e.id == moduleId)
            },

            findLaboratoryNameFromMetadataBySession(metadata, sessionId) {
                if (!('training' in metadata)) {
                    return false
                }
                return metadata.training.find(e => e.trainingSessionId == sessionId);
            },

            exportUsersTable() {
                let multiData = [];

                {
                    const tHeader = [
                        '#', 'Id', 'Email', 'first Name', 'Last Name', 'Gender', 'Training'
                    ];


                    const filterVal = [
                        '#', 'id', 'emailAddress', 'firstName', 'lastName', 'gender', 'sessionData'
                    ];

                    const deepValues = {
                        sessionData(item) {
                            if (!item.sessionData.length) return '-';
                            return item.sessionData.map(e => `Date: ${e.date} | Module name ${e.trainingModuleName} | Lab: ${e.labName}`).join('\n');
                        },
                    };

                    let data = this.laboratoryFilteredUsers.map((v, index) => {
                        return filterVal.map(j => {
                            if (j === '#') return index + 1;
                            if (v[j]) {
                                if (j in deepValues) {
                                    return deepValues[j](v)
                                } else {
                                    return v[j].toString()
                                }
                            }

                            return ''
                        });
                    }).filter(e => e);

                    multiData.push({name: 'Training', header: tHeader, data})
                }

                export_json_to_excel_custom({
                    multiData,
                    filename: 'training',
                    autoWidth: true,
                })

            },

            exportModulesTable() {
                let multiData = [];

                {
                    const tHeader = [
                        '#', 'Id', 'Name', 'Duration', 'Sessions', 'Trained Users'
                    ];


                    const filterVal = [
                        '#', 'id', 'name', 'duration', 'sessions', 'trainedUsers'
                    ];

                    const deepValues = {
                        sessions(item) {
                            let textData = '';
                            let iterations = item.sessions.length;

                            for(let session of item.sessions) {
                                textData += `${session.dateRange.split(',').join(' ~ ')} / ${session.users.length}`;

                                if(--iterations) {
                                    textData += '\n';
                                }
                            }

                            return textData
                        },
                    };

                    let data = this.trainingModules.map((v, index) => {
                        return filterVal.map(j => {
                            if (j === '#') return index + 1;
                            if (v[j]) {
                                if (j in deepValues) {
                                    return deepValues[j](v)
                                } else {
                                    return v[j].toString()
                                }
                            }

                            return ''
                        });
                    }).filter(e => e);

                    multiData.push({name: 'Training', header: tHeader, data})
                }

                export_json_to_excel_custom({
                    multiData,
                    filename: 'training-modules',
                    autoWidth: true,
                })

            }
        }

    }
</script>

<style scoped>

</style>
